export default __webpack_public_path__ + "static/media/GA.c6e80c81.svg";